export default {
  headline: 'Velkommen',
  welcomeText: process.env.VUE_APP_WELCOME_TEXT_EN ||
  'til innovation mecoms læringsstyringssystem.'
}
